import { Box, Grid, Rating, Hidden, useTheme, useMediaQuery } from '@hermes/web-components'
import TrustRatingStatistic from '../../TrustRatingStatistic'
import useTranslateMessage from '../../../../../../hooks/useTranslateMessage'
import { RatingStarsContainer, ReviewsCount, ReviewsSummary } from './styles'

const fitContentString = 'fit-content'

export type ProfileRatingProps = {
  isPractice: boolean
  averageRating?: number
  profileReviewTotal?: number
  peerRecommendationsCount?: number
  handleOpenProfilePageReviews: () => void
}

const ProfileRating = ({
  isPractice,
  averageRating,
  profileReviewTotal,
  peerRecommendationsCount,
  handleOpenProfilePageReviews
}: ProfileRatingProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const translate = useTranslateMessage()

  return (
    <Grid container>
      <RatingStarsContainer container>
        <Box display="flex" alignItems="flex-end">
          <ReviewsSummary>
            {averageRating ? averageRating?.toFixed?.(2) : '-'}
            <span>/5</span>
          </ReviewsSummary>
        </Box>
        <Rating
          value={Number(averageRating) || 0}
          size="small"
          sx={{ fontSize: 16, height: fitContentString }}
          readOnly
        />
        {profileReviewTotal !== undefined && (
          <ReviewsCount
            onClick={(e) => {
              if (isMobile) {
                e.stopPropagation()
                handleOpenProfilePageReviews()
              }
            }}
            variant="body2"
          >
            ({profileReviewTotal} {translate('reviews_one')})
          </ReviewsCount>
        )}
      </RatingStarsContainer>
      {!isPractice && !!peerRecommendationsCount && (
        <Grid container component={Hidden} lgDown implementation="css" justifyContent="center" pt="8px">
          <Grid>
            <TrustRatingStatistic
              count={peerRecommendationsCount || 0}
              name={translate('search.peer_endorsements', { count: peerRecommendationsCount || 0 })}
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}

export default ProfileRating
